import { Authority } from '../request'

const { get } = Authority

// 路线区间统计
export const getRoadCount = params => get('/statistics/road/v1/roadCount', { params })
// 地灾点统计
export const getDamageCount = params => get('/statistics/road/v1/damageCount', { params })
// 边坡统计
export const getSlopeCount = params => get('/statistics/road/v1/slopeCount', { params })
